import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedCreateDocumentGroupReq } from 'app/interfaces/requests/Exposed/exposedCreateDocumentGroupReq';
import { ExposedCreateDocumentReq } from 'app/interfaces/requests/Exposed/exposedCreateDocumentReq';
import { ExposedCreateDocumentTemplateReq } from 'app/interfaces/requests/Exposed/exposedCreateDocumentTemplateReq';
import { ExposedDeleteDocumentReq } from 'app/interfaces/requests/Exposed/exposedDeleteDocumentReq';
import { ExposedListDocumentReq } from 'app/interfaces/requests/Exposed/exposedListDocumentReq';
import { ExposedListDocumentTemplatesReq } from 'app/interfaces/requests/Exposed/exposedListDocumentTemplatesReq';
import { ExposedReadDocumentReq } from 'app/interfaces/requests/Exposed/exposedReadDocumentReq';
import { ExposedUploadGroupDocumentFileReq } from 'app/interfaces/requests/Exposed/exposedUploadGroupDocumentFileReq';
import { ExposedWithdrawDocumentReq } from 'app/interfaces/requests/Exposed/exposedWithdrawDocumentReq';
import { ListBrefLoggurHoparReq } from 'app/interfaces/requests/List/listBrefLoggurHoparReq';
import { ListBrefLoggurHopurReq } from 'app/interfaces/requests/List/listBrefLoggurHopurReq';
import { ExposedCreateDocumentRes } from 'app/interfaces/responses/Exposed/exposedCreateDocumentRes';
import { ExposedDeleteDocumentRes } from 'app/interfaces/responses/Exposed/exposedDeleteDocumentRes';
import { ExposedListDocumentRes } from 'app/interfaces/responses/Exposed/exposedListDocumentRes';
import { ExposedListDocumentTypeRes } from 'app/interfaces/responses/Exposed/exposedListDocumentTypeRes';
import { ExposedReadDocumentRes } from 'app/interfaces/responses/Exposed/exposedReadDocumentRes';
import { ExposedReadJobDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadJobDetailsRes';
import { ListBrefLoggurHoparRes } from 'app/interfaces/responses/List/listBrefLoggurHoparRes';
import { ListBrefLoggurHopurRes } from 'app/interfaces/responses/List/listBrefLoggurHopurRes';
import { ListDocumentCategoryRes } from 'app/interfaces/responses/List/listDocumentCategoryRes';
import { ListDocumentSubcategoryRes } from 'app/interfaces/responses/List/listDocumentSubcategoryRes';
import { ListDocumentSystemRes } from 'app/interfaces/responses/List/listDocumentSystemRes';
import { ListDocumentTemplatesRes } from 'app/interfaces/responses/List/listDocumentTemplatesRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { catchError, finalize, map, Observable, of, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SkjalamidjaService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router,
        public dialog: MatDialog
    ) {}

    public uploadDocument(
        req: ExposedCreateDocumentReq,
        file: File,
        showError = true,
        showSuccess = true,
        showLoader = true
    ): Observable<ExposedCreateDocumentRes> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Skrái skjal');
        }

        const subject = new Subject<ExposedCreateDocumentRes>();

        var formData = this.createGeneralFormDataFromRequest(req);
        formData.append('FileExtension', req.fileExtension || '');
        formData.append('AzureLocation', req.azureLocation || '');
        formData.append('SSN', req.Ssn || '');
        formData.append('file', file, file.name);

        this.http
            .post(
                environment.localApi + 'skjalamidja/uploadDocument/file',
                formData,
                this.httpRequestHelper.getRequestOptionsAuthFileUpload()
            )
            .subscribe(
                (res: HttpStatus<ExposedCreateDocumentRes>) => {
                    subject.next(res.returnItem);
                    if (showSuccess) {
                        this.alertsService.changeAlertShowIcon(true);
                        this.alertsService.changeAlertSuccessMessage('Skjal hefur verið skráð');
                        this.alertsService.changeAlertSuccessShow(true);
                    }
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                    subject.next({
                        createDocSuccess: false,
                        stafraentIslandSuccess: false,
                    });
                }
            )
            .add(() => {
                if (showLoader) {
                    this.loaderService.changeActiveLoaders(-1);
                }
            });

        return subject.asObservable();
    }

    public uploadDocumentFromTemplate(
        req: ExposedCreateDocumentTemplateReq,
        additionalDocuments: File[],
        showError = true,
        showSuccess = true,
        showLoader = true
    ): Observable<ExposedCreateDocumentRes> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Skrái skjal úr sniðmáti');
        }

        const subject = new Subject<ExposedCreateDocumentRes>();

        var formData = this.createGeneralFormDataFromRequest(req);
        formData.append('ssn', req.ssn || '');
        formData.append('documentTemplateKey', req.documentTemplateKey || '');

        // Send templateData as JSON if it exists.
        if (req.templateData != null) {
            formData.append('templateData', req.templateData);
        }

        // Send additional documents if they exist.
        for (const file of additionalDocuments) {
            formData.append('additionalDocuments', file, file.name);
        }

        this.http
            .post(
                environment.localApi + 'skjalamidja/uploadDocument/template',
                formData,
                this.httpRequestHelper.getRequestOptionsAuthFileUpload()
            )
            .subscribe(
                (res: HttpStatus<ExposedCreateDocumentRes>) => {
                    subject.next(res.returnItem);
                    if (showSuccess) {
                        this.alertsService.changeAlertShowIcon(true);
                        this.alertsService.changeAlertSuccessMessage('Skjal hefur verið skráð');
                        this.alertsService.changeAlertSuccessShow(true);
                    }
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                    subject.next({
                        createDocSuccess: false,
                        stafraentIslandSuccess: false,
                    });
                }
            )
            .add(() => {
                if (showLoader) {
                    this.loaderService.changeActiveLoaders(-1);
                }
            });

        return subject.asObservable();
    }

    public getUploadedDocumentFromTemplatePreview(
        req: ExposedCreateDocumentTemplateReq,
        additionalDocuments: File[] = []
    ): Observable<ExposedReadDocumentRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Undirbý skjal');

        const subject = new Subject<ExposedReadDocumentRes>();

        // Primitive fields
        var formData = this.createGeneralFormDataFromRequest(req);
        formData.append('ssn', req.ssn || '');
        formData.append('documentTemplateKey', req.documentTemplateKey || '');

        // Send templateData as JSON if it exists.
        if (req.templateData != null) {
            formData.append('templateData', req.templateData);
        }

        // Send additional documents if they exist.
        for (const file of additionalDocuments) {
            formData.append('additionalDocuments', file, file.name);
        }

        this.http
            .post(
                environment.localApi + 'skjalamidja/uploadDocument/template/preview',
                formData,
                this.httpRequestHelper.getRequestOptionsAuthFileUpload()
            )
            .subscribe(
                (res: HttpStatus<ExposedReadDocumentRes>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    subject.next(null);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });

        return subject.asObservable();
    }

    public withdrawDocument(req: ExposedWithdrawDocumentReq, loaderMessage = 'Eyði skjali'): Observable<ExposedCreateDocumentRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage(loaderMessage);

        let subject = new Subject<ExposedCreateDocumentRes>();
        this.http
            .post(environment.localApi + 'skjalamidja/withdrawDocument', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<ExposedCreateDocumentRes>) => {
                    subject.next(res.returnItem);
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage('Skjal hefur verið eytt');
                    this.alertsService.changeAlertSuccessShow(true);
                },
                (error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    subject.next({
                        createDocSuccess: false,
                        stafraentIslandSuccess: false,
                    });
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public deleteDocument(req: ExposedDeleteDocumentReq, loaderMessage = 'Eyði skjali'): Observable<ExposedDeleteDocumentRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage(loaderMessage);

        let subject = new Subject<ExposedDeleteDocumentRes>();
        this.http
            .post(environment.localApi + 'skjalamidja/deleteDocument', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<ExposedDeleteDocumentRes>) => {
                    subject.next(res.returnItem);
                    if ((res.returnItem.removedFromDigitalIceland || res.returnItem.removedFromDigitalIceland == null) && res.returnItem.removedFromLSRDocuments)
                    {
                        this.alertsService.changeAlertShowIcon(true);
                        this.alertsService.changeAlertSuccessMessage('Skjali hefur verið eytt');
                        this.alertsService.changeAlertSuccessShow(true);
                    }
                    else if (!res.returnItem.removedFromDigitalIceland && res.returnItem.removedFromDigitalIceland != null) {
                        this.alertsService.changealertHeader('Villur við að eyða skjali');
                        this.alertsService.changeAlertErrorMessage('Ekki tókst að eyða skjali af Stafrænt Ísland.is');
                        this.alertsService.changeAlertErrorShow(true);
                    }
                    else if (!res.returnItem.removedFromLSRDocuments) {
                        this.alertsService.changealertHeader('Villur við að eyða skjali');
                        this.alertsService.changeAlertErrorMessage('Ekki tókst að eyða skjali');
                        this.alertsService.changeAlertErrorShow(true);
                    }
                },
                (error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    subject.next({
                        removedFromDigitalIceland: false,
                        removedFromLSRDocuments: false,
                        });
                    }
                )
                .add(() => {
                    this.loaderService.changeActiveLoaders(-1);
                });
            return subject.asObservable();
    }

    public submitToPortalLSR(documentId: number): Observable<boolean> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sendi skjal á Mínar síður');

        return this.http
            .post(`${environment.localApi}skjalamidja/${documentId}/submitToPortalLSR`, this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res: HttpStatus<boolean>) => {
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage('Skjal hefur verið sent á Mínar síður');
                    this.alertsService.changeAlertSuccessShow(true);

                    return res.returnItem;
                }),
                catchError((error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    return of(false);
                }),
                finalize(() => {
                    this.loaderService.changeActiveLoaders(-1);
                })
            );

    }

    public submitToDigitalIceland(documentId: number): Observable<boolean> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sendi skjal á Ísland.is');

        return this.http
            .post(`${environment.localApi}skjalamidja/${documentId}/submitToDigitalIceland`, this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res: HttpStatus<boolean>) => {
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage('Skjal sent til Íslands.is');
                    this.alertsService.changeAlertSuccessShow(true);

                    return res.returnItem;
                }),
                catchError((error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    return of(false);
                }),
                finalize(() => {
                    this.loaderService.changeActiveLoaders(-1);
                })
            );
    }

    public uploadDocumentGroupTemplate(
        req: ExposedCreateDocumentGroupReq,
        files: File[] = [],
        showError = true,
        showSuccess = true
    ): Observable<ExposedReadJobDetailsRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Skrái bunka');

        const subject = new Subject<ExposedReadJobDetailsRes>();

        var formData = this.createGeneralFormDataFromRequest(req);
        formData.append('documentTemplateKey', req.documentTemplateKey || '');
        formData.append('groupId', req.groupId?.toString() || '');

        // Send templateData as JSON if it exists.
        if (req.templateData != null) {
            formData.append('templateData', JSON.stringify(req.templateData));
        }

        // Send additional documents if they exist.
        for (const file of files) {
            formData.append('additionalDocuments', file, file.name);
        }

        this.http
            .post(
                environment.localApi + 'skjalamidja/uploadDocumentGroup/template',
                formData,
                this.httpRequestHelper.getRequestOptionsAuthFileUpload()
            )
            .subscribe(
                (res: HttpStatus<ExposedReadJobDetailsRes>) => {
                    subject.next(res.returnItem);
                    if (showSuccess) {
                        this.alertsService.changeAlertShowIcon(true);
                        this.alertsService.changeAlertSuccessMessage('Bunki hefur verið skráður');
                        this.alertsService.changeAlertSuccessShow(true);
                    }
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                    subject.next(null);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });

        return subject.asObservable();
    }

    public uploadDocumentGroupFile(
        req: ExposedUploadGroupDocumentFileReq,
        file: File,
        showError = true,
        showSuccess = true
    ): Observable<ExposedReadJobDetailsRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Skrái bunka');

        const subject = new Subject<ExposedReadJobDetailsRes>();

        var formData = this.createGeneralFormDataFromRequest(req);
        formData.append('groupId', req.groupId.toString());
        formData.append('file', file, file.name);

        this.http
            .post(
                environment.localApi + 'skjalamidja/uploadDocumentGroup/file',
                formData,
                this.httpRequestHelper.getRequestOptionsAuthFileUpload()
            )
            .subscribe(
                (res: HttpStatus<ExposedReadJobDetailsRes>) => {
                    subject.next(res.returnItem);
                    if (showSuccess) {
                        this.alertsService.changeAlertShowIcon(true);
                        this.alertsService.changeAlertSuccessMessage('Bunki hefur verið skráður');
                        this.alertsService.changeAlertSuccessShow(true);
                    }
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                    subject.next(null);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });

        return subject.asObservable();
    }

    // Helper function to create a FormData object from a request object that contains general document information.
    private createGeneralFormDataFromRequest = (
        req: ExposedUploadGroupDocumentFileReq | ExposedCreateDocumentGroupReq | ExposedCreateDocumentTemplateReq | ExposedCreateDocumentReq
    ): FormData => {
        const formData = new FormData();

        formData.append('title', req.title || '');
        formData.append('description', req.description || '');
        formData.append('documentDate', req.documentDate ? new Date(req.documentDate).toISOString() : new Date().toISOString());
        formData.append('documentTypeId', req.documentTypeId?.toString() || '');
        formData.append('documentCategoryId', req.documentCategoryId?.toString() || '');
        formData.append('documentSubcategoryId', req.documentSubcategoryId?.toString() || '');
        formData.append('documentSystemId', req.documentSystemId?.toString() || '');
        formData.append('publicationDate', req.publicationDate ? new Date(req.publicationDate).toISOString() : new Date().toISOString());
        formData.append('svid', req.svid || '');
        formData.append('deild', req.deild || '');
        formData.append('submitToStafraentIsland', req.submitToStafraentIsland?.toString() ?? 'false');
        formData.append('submitToPortalLSR', req.submitToPortalLSR?.toString() ?? 'false');

        return formData;
    };

    public listDocuments(req: ExposedListDocumentReq, showError = true): Observable<Array<ExposedListDocumentRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki skjöl');

        let subject = new Subject<Array<ExposedListDocumentRes>>();
        this.http
            .post(environment.localApi + 'skjalamidja/listDocuments', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ExposedListDocumentRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public readDocument(req: ExposedReadDocumentReq, fetchBlob = true, showError = true): Observable<ExposedReadDocumentRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki skjal');

        let subject = new Subject<ExposedReadDocumentRes>();
        this.http
            .post(environment.localApi + 'skjalamidja/readDocument/' + fetchBlob, req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<ExposedReadDocumentRes>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listCategories(showError = true): Observable<Array<ListDocumentCategoryRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        let subject = new Subject<Array<ListDocumentCategoryRes>>();
        this.http
            .get(environment.localApi + 'skjalamidja/listCategories', this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ListDocumentCategoryRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listSubcategories(showError = true): Observable<Array<ListDocumentSubcategoryRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        let subject = new Subject<Array<ListDocumentSubcategoryRes>>();
        this.http
            .get(environment.localApi + 'skjalamidja/listSubcategories', this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ListDocumentSubcategoryRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listTypes(showError = true): Observable<Array<ExposedListDocumentTypeRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        let subject = new Subject<Array<ExposedListDocumentTypeRes>>();
        this.http
            .get(environment.localApi + 'skjalamidja/listTypes', this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ExposedListDocumentTypeRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listSystems(showError = true): Observable<Array<ListDocumentSystemRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        let subject = new Subject<Array<ListDocumentSystemRes>>();
        this.http
            .get(environment.localApi + 'skjalamidja/listSystems', this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ListDocumentSystemRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listDocumentTemplates(showError = true, req: ExposedListDocumentTemplatesReq): Observable<Array<ListDocumentTemplatesRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        let subject = new Subject<Array<ListDocumentTemplatesRes>>();
        this.http
            .post(environment.localApi + 'skjalamidja/listDocumentTemplates', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ListDocumentTemplatesRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listBrefLoggurHopar(req: ListBrefLoggurHoparReq, showError = true): Observable<Array<ListBrefLoggurHoparRes>> {
        let subject = new Subject<Array<ListBrefLoggurHoparRes>>();
        this.http
            .post(environment.localApi + 'skjalamidja/bunki/kria/listBrefLoggurHopar', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ListBrefLoggurHoparRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                    subject.next(null);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listBrefLoggurHopur(req: ListBrefLoggurHopurReq, showError = true): Observable<Array<ListBrefLoggurHopurRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        let subject = new Subject<Array<ListBrefLoggurHopurRes>>();
        this.http
            .post(environment.localApi + 'skjalamidja/bunki/kria/listBrefLoggurHopur', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ListBrefLoggurHopurRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                subject.next(null);
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }
}
